import React from 'react';
import tw from 'twin.macro';
import { navigate } from 'gatsby';
import { css } from '@emotion/react';
import { useLocation } from '@reach/router';

import Dropdown from '$/components/ui/Input/Basics/Dropdown';
import { useThemeContext } from '$/components/ui/ThemeContext';

import { isMatchPath } from '$/utils/hasPermission';
import { rolesPermissionsMatrix, getRoute } from '$/utils/pathConfig';
import { useHomePageSetsQuery, HomePageSetFragment } from '$/GraphQL/schema/schema';

import { getPublishedSets } from './getPublishedSets';

const DashboardRoutes = [
  rolesPermissionsMatrix.portalDashboardAnalytics.path,
  rolesPermissionsMatrix.portalDashboardInteractions.path,
  rolesPermissionsMatrix.portalDashboardRegistrants.path,
  rolesPermissionsMatrix.portalDashboardChat.path,
];
const conversationRoute = rolesPermissionsMatrix.portalDashboardChat.path + '/:conversationId';

const getNewPath = (setId: string, currentPath: string): string | undefined => {
  let path = DashboardRoutes.find((path) => isMatchPath(path, currentPath));
  if (!path && isMatchPath(conversationRoute, currentPath)) {
    path = rolesPermissionsMatrix.portalDashboardChat.path;
  }
  return path
    ? getRoute(path, {
        setId: setId,
      })
    : undefined;
};

const DashboardTitle: React.FC<{ setId: string; className?: string }> = ({ setId, className }) => {
  const etheme = useThemeContext();
  const { pathname } = useLocation();
  const setsQuery = useHomePageSetsQuery({ fetchPolicy: 'cache-only' });
  const sets = setsQuery.data && setsQuery.data.homePageSets;
  const publishedSets: HomePageSetFragment[] = getPublishedSets(sets ?? []);
  const options = publishedSets.map((set, index) => {
    return {
      key: index,
      text: set.title,
      value: set.id,
    };
  });

  return (
    <div
      className={className}
      css={css`
        display: flex;
        margin-left: -0.75rem;
        max-width: 46rem;
        .ui.selection.dropdown .menu {
          ${tw`z-header`}
          & > .item {
            max-width: 46rem;
            padding: 0 2rem 0 1rem !important;
            line-height: normal !important;
          }
        }
        .ui.selection.dropdown {
          background: transparent !important;
          ${tw`text-header-fg!`};
          opacity: 0.9;
          padding: 0 2.1em 0 1em;

          border-width: 0 !important;
          box-shadow: none !important;
          line-height: normal !important;
          min-height: auto !important;
          &:hover {
            opacity: 1;
          }
          &.active {
            color: ${etheme.header.fg};
            background: ${etheme.header.bg};
            opacity: 1;

            .text,
            .item {
              ${tw`font-light`}
            }
          }
          .listbox {
            padding-top: 5px;
            padding-bottom: 5px;
          }
          .text {
            ${tw`block font-light truncate`}
          }
          .menu {
            border-top-width: 1px !important;
            min-width: max-content !important;
          }
        }
      `}
    >
      <Dropdown
        className='dashboard-title'
        value={setId}
        options={options}
        onChange={(value): void => {
          const path = getNewPath(value, pathname);
          if (path) {
            navigate(path);
          }
        }}
      />
    </div>
  );
};

export default DashboardTitle;
